import { GetServerSideProps } from 'next';
import { getDataHooksProps } from 'next-data-hooks';

import { HeaderFooterWrapper } from '../components/_shared/header-footer-wrapper/header-footer-wrapper';
import { resolveLanguageAndRedirect } from '../utils/_helper/resolve-language-and-redirect-helper';
import { setHeaders } from '../utils/_helper/set-headers';
import Marketplace from '../views/marketplace/marketplace';
import MyApp from './_app';

export default Marketplace;

export const getServerSideProps: GetServerSideProps = async (context) => {
    setHeaders(context);

    const redirect = await resolveLanguageAndRedirect(context);

    if (redirect) return { redirect };
    const dataHooksProps = await getDataHooksProps({
        context,
        dataHooks: [
            ...HeaderFooterWrapper.dataHooks,
            ...Marketplace.dataHooks,
            ...MyApp.dataHooks
        ]
    });
    return {
        props: { ...dataHooksProps }
    };
};
